import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const coreSummaryActions = createDataModuleActions('CORE_SUMMARY');
export const coreSummaryRequest = coreSummaryActions.dataRequest;
export const coreSummarySuccess = coreSummaryActions.dataSuccess;
export const coreSummaryError = coreSummaryActions.dataError;
export const coreSummaryReset = coreSummaryActions.dataReset;
